module.exports = __webpack_public_path__ + "static/media/forest-tyrannosaure.30ec5f69.png";